import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Route } from '@df/catalog/route/route';
import { HTTPStatus, MetaState, metaStateFactory } from '@df/core/meta/meta-state';
import { NCore } from '../df-core.interfaces';

@Injectable({
    providedIn: 'root'
})
export class MetaStateFactory {
    constructor(
        protected router: Router,
        @Inject(NCore.OPTIONS) protected options: NCore.IModuleOptions
    ) {}

    getMetaState(url: string, route: Route | undefined, previousState?: MetaState, forcedStatus?: HTTPStatus): MetaState {
        return new metaStateFactory.instance(this.options, url, route, this.router.routerState, previousState, forcedStatus);
    }
}
